import * as React from 'react';
import { Box } from '@mui/material';
import { STATUS_NEW, STATUS_RESOLVED, STATUS_IN_PROGRESS, STATUS_READY_TO_RESOLVE} from '../../Constants/Global';


//const STATUS_NEW = 1
//const STATUS_IN_PROGRESS = 2
//const STATUS_RESOLVED = 3
//const STATUS_READY_TO_RESOLVE = 4

/**
 * A schedule icon component that displays the number of days left or a checkmark if the task is completed.
 * The icon's appearance (size, position, etc.) can be customized based on the context (e.g., calendar or forms).
 * 
 * @component
 * @example
 * <ScheduleIcon daysLeft={5} status={1} fromCalendar={true} />
 * @param {Object} props - The component props.
 * @param {number} props.daysLeft - The number of days left for the task or process.
 * @param {number} props.status - The status of the task or process.
 * @param {boolean} props.fromCalendar - Whether the icon is displayed in a calendar context.
 * @returns {JSX.Element} The rendered schedule icon component.
 */
function ScheduleIcon(props) {
  const { daysLeft, status, fromCalendar} = props;

  /**
   * Calculates the background color for the schedule icon based on the days left and status.
   * 
   * @param {number} daysLeft - The number of days left for the task or process.
   * @param {number} status - The status of the task or process.
   * @returns {string} The background color for the icon.
   */
  const calcBackground = (daysLeft, status) => {
  let color = "";
  switch (status) {
    case STATUS_RESOLVED:
        color = "#63cf63"   //green
        break;
    case STATUS_IN_PROGRESS:
        color = "#63cf63"   //green
        break;
    default:
        color = "#FFD54F" //yellow
        //color = "#d97575" //red
    }

    return color;

    //return daysLeft > 0  || status === 3? "#63cf63" : "#d97575";

  }

  // Define the base styles for the icon
  let styles = {
    borderRadius: "100%", 
    border: "solid 1px",
    textAlign: "center", 
    background: calcBackground(daysLeft, status), 
    color: "white", 
  }

  // Adjust styles based on the context (calendar or forms)
  if (fromCalendar){
    styles = {
      ...styles,
      width: "18px", 
      height: "18px", 
      minWidth: "18px", 
      minHeight: "18px", 
      fontSize: "12px",
      position: "absolute",
      bottom: "7px",
      left: "-4px"
    };
  } else {
    styles = {
      ...styles,
      width: "25px", 
      height: "25px", 
      minWidth: "25px", 
      minHeight: "25px", 
      fontSize: "18px",
      marginLeft: "auto"
    };
  }


  return <>
    <Box sx={styles}>
      {status === 3? "🗸" : props.daysLeft > 0? props.daysLeft: "!" }
    </Box>
  </>
}

export default ScheduleIcon;
